<template>
  <div>
    <div v-if="selectedPhoto && !addPhoto" class="selectedPhoto">
      <p class="is-size-6 has-text-primary">Details geselecteerde foto:</p>
      <table class="printblock-table">
        <tr>
          <td>Datum:</td>
          <td>{{ new Date(selectedPhoto.captureTime).toLocaleDateString('nl-NL') }}</td>
          <td>Gebruiker:</td>
          <td-user :username="selectedPhoto.captureUser" />
        </tr>
        <tr>
          <td>Status:</td>
          <td colspan="3">{{ selectedPhoto.registrationType | statusPhoto }}</td>
        </tr>
        <tr>
          <td>Commentaar:</td>
          <td colspan="3">{{ selectedPhoto.comment }}</td>
        </tr>
      </table>

      <img v-if="selectedPhoto.notUri" :src="selectedPhoto.notUri" @click="showPhotoModal = true" class="photoHover" />
      <img v-else :src="selectedPhoto.uri" @click="showPhotoModal = true" class="photoHover" />
    </div>
    <div v-else-if="addPhoto">
      <p class="is-size-5 has-text-primary">Upload Uw Foto:</p>
      <div class="columns">
        <div class="column">
          <b-field class="custom-upload">
            <b-upload v-model="dropFiles" @input="imagePreview" drag-drop accept="image/*">
              <section class="section">
                <div class="content has-text-centered" v-if="dropFiles.length == 0">
                  <p>
                    <b-icon icon="upload" size="is-large"></b-icon>
                  </p>
                  <p>Drop your files here or click to upload</p>
                </div>
                <div v-if="dropFiles.length != 0">
                  <div class="file-listing">
                    <img class="preview" ref="preview" />
                  </div>
                </div>
              </section>
            </b-upload>
          </b-field>
          <!-- <div id="app">
              <vue-dropzone ref="vueDropzone" id="customdropzone" :options="dropOptions"></vue-dropzone>
                </div>-->
        </div>
        <div class="column">
          <br />
          <b-field label="Status">
            <b-select placeholder="Selecteer een Status" v-model="selectedStatus">
              <option v-for="option in options" :key="option">{{ option }}</option>
            </b-select>
          </b-field>
          <b-field label="Commentaar">
            <b-input maxlength="200" type="textarea" style="width: 280px" v-model="comment"></b-input>
          </b-field>
          <a class="button is-dark custom" @click="deleteDropFile()">Reset</a>
          <a class="button is-primary custom" @click="submitFiles()" :disabled="this.photo == ''">Save</a>
        </div>
      </div>
    </div>
    <div v-else>
      <h2 class="is-size-5 has-text-primary modaltitle">Geen sparing gevonden of er is iets fout gegaan.</h2>
    </div>
    <b-modal :active.sync="showPhotoModal" v-if="selectedPhoto" class="photoModal">
      <img v-if="selectedPhoto.notUri" :src="selectedPhoto.notUri" class="photoModalImage" />
      <img v-else :src="selectedPhoto.uri" class="photoModalImage" />
    </b-modal>
  </div>
</template>
<script>
import editable from '@/components/Projects/editable.vue'
import TdUser from '../General/TdUser.vue'
export default {
  filters: {
    // stripEmail: function (value) {
    //   if (!value) return ''
    //   if (!value.includes('@')) return value

    //   const i = value.indexOf('@')
    //   return value.substring(0, i)
    // },
    statusPhoto: function (value) {
      if (!value) return ''
      let res = ''

      switch (value) {
        case 0:
          res = 'Geen'
          break
        case 1:
          res = 'Offerteopname: geen QR'
          break
        case 2:
          res = 'Vooropname: niet akkoord'
          break
        case 3:
          res = 'Vooropname: akkoord'
          break
        case 4:
          res = 'Montage: niet akkoord'
          break
        case 5:
          res = 'Montage: akkoord'
          break
        case 6:
          res = 'Inspectie: akkoord'
          break
        case 7:
          res = 'Inspectie: niet akkoord'
          break
        case 8:
          res = 'Inspectie periodiek: akkoord'
          break
        case 9:
          res = 'Mutatie: reparatie/herstel'
          break
        default:
          break
      }
      return res
    }
  },
  components: {
    editable,
    TdUser
  },
  props: {
    selectedPhoto: {
      type: Object
    },
    editMode: {
      type: Boolean,
      default: false
    },
    addPhoto: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dropFiles: [],
      showPhotoModal: false,
      options: [
        'Geen',
        'Offerteopname: geen QR',
        'Vooropname: niet akkoord',
        'Vooropname: akkoord',
        'Montage: niet akkoord',
        'Montage: akkoord',
        'Inspectie: akkoord',
        'Inspectie: niet akkoord',
        'Inspectie periodiek: akkoord',
        'Mutatie: reparatie/herstel'
      ],
      comment: '',
      selectedStatus: 0,
      photo: null
    }
  },
  methods: {
    async submitFiles() {
      if (this.photo != '') {
        const data = this.photo.split(',')[1]
        const photoInfo = {
          photo: data,
          comment: this.comment,
          RegistrationType: this.options.findIndex(o => o == this.selectedStatus)
        }
        const today = new Date(Date.now())
        photoInfo.captureTime = today.toJSON()
        photoInfo.captureUser = this.$store.getters.user.email
        photoInfo.notUri = this.photo
        photoInfo.registrationType = photoInfo.RegistrationType
        this.$emit('submit', photoInfo)
        this.photo = null
        this.comment = ''
        this.selectedStatus = 0
        this.dropFiles = []
      }
    },
    imagePreview: function (event) {
      const input = event
      if (event != null) {
        const reader = new FileReader()
        reader.onload = e => {
          this.$refs['preview'].src = reader.result
          this.photo = reader.result
        }
        reader.readAsDataURL(input)
      }
    },
    deleteDropFile() {
      this.dropFiles = []
      this.photo = null
      this.selectedStatus = 0
      this.comment = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Projects/OpeningPhoto.vue